import {
  ITreatmentPlan,
  IPhaseItems,
  TX_PLAN_STATUS,
} from '@dataTypes/treatmentPlan.types'
import { ProcedureSettingsType } from '@dataTypes/procedureSettings.type'
import moment from 'moment'

const createProcedureSettings = (
  procedure_id: string,
  procedure_code: string,
  description: string,
): ProcedureSettingsType => ({
  procedure_setting_id: `mock-clinical-proc-${procedure_id}`,
  appointment_type_subcategory_id: 'subcat-1',
  procedure_id,
  description,
  fee1: 150,
  fee2: 200,
  fee3: 250,
  date_time_created_at: moment().subtract(1, 'month').toISOString(),
  date_time_updated_at: moment().subtract(1, 'month').toISOString(),
  procedure: {
    procedure_id,
    procedure_code,
    description,
  },
})

const createPhaseItem = (
  itemId: string,
  phaseId: string,
  procedureId: string,
  code: string,
  description: string,
  surface: string,
  charges: number,
): IPhaseItems => ({
  item_id: itemId,
  phase_id: phaseId,
  procedure_id: procedureId,
  provider_id: 'mock-provider-1',
  surface,
  charges,
  insurance: Math.round(charges * 0.8),
  adjustments: 2,
  outstanding: Math.round(charges * 0.18),
  allowed_amount: charges,
  write_off: 0,
  procedure_settings: createProcedureSettings(procedureId, code, description),
})

export const DEMO_CLINICAL_TREATMENT_PLANS: ITreatmentPlan[] = [
  {
    tp_id: 'demo-clinical-tp-1',
    patient_id: 'mock-patient-1',
    clinic_id: 'clinic-1',
    insurance_plan_id: 'ins-1',
    tp_heading: 'John Tx 1',
    tp_note: '',
    tp_type: 'Comprehensive',
    isDraft: false,
    discount_id: null,
    discount: 0,
    date_time_created_at: moment('2024-06-12').toISOString(),
    date_time_updated_at: moment('2024-08-12').toISOString(),
    phases: [
      {
        phase_id: 'demo-clinical-phase-1',
        phase_name: 'Phase 1',
        scheduled_date: null,
        status: TX_PLAN_STATUS.PROPOSED,
        items: [
          createPhaseItem(
            'demo-clinical-item-1',
            'demo-clinical-phase-1',
            'proc-c1',
            'D2544',
            'Onlay - metallic - four or more surfaces',
            '16/-',
            100,
          ),
          createPhaseItem(
            'demo-clinical-item-2',
            'demo-clinical-phase-1',
            'proc-c2',
            'D2630',
            'Inlay - porcelain/ceramic - three or more surfaces',
            '17/MOD',
            100,
          ),
          createPhaseItem(
            'demo-clinical-item-3',
            'demo-clinical-phase-1',
            'proc-c3',
            'D0602',
            'Caries risk assessment and documentation, with a finding of moderate risk',
            '3/D',
            100,
          ),
          createPhaseItem(
            'demo-clinical-item-4',
            'demo-clinical-phase-1',
            'proc-c4',
            'D1105',
            'Removal of plaque, calculus, and stain from teeth',
            '2/D',
            100,
          ),
        ],
      },
      {
        phase_id: 'demo-clinical-phase-2',
        phase_name: 'Phase 2',
        scheduled_date: null,
        status: TX_PLAN_STATUS.PROPOSED,
        items: [
          createPhaseItem(
            'demo-clinical-item-5',
            'demo-clinical-phase-2',
            'proc-c5',
            'D2391',
            'Resin-based composite - one surface, anterior',
            '14/O',
            550,
          ),
        ],
      },
      {
        phase_id: 'demo-clinical-phase-3',
        phase_name: 'Phase 3',
        scheduled_date: '2024-08-12',
        status: TX_PLAN_STATUS.REJECTED,
        items: [
          createPhaseItem(
            'demo-clinical-item-6',
            'demo-clinical-phase-3',
            'proc-c6',
            'D2140',
            'Amalgam restoration - one surface',
            '19/DO',
            550,
          ),
        ],
      },
    ],
  },
  {
    tp_id: 'demo-clinical-tp-2',
    patient_id: 'mock-patient-1',
    clinic_id: 'clinic-1',
    insurance_plan_id: 'ins-1',
    tp_heading: 'Plan 2 C',
    tp_note: '',
    tp_type: 'Comprehensive',
    isDraft: false,
    discount_id: null,
    discount: 0,
    date_time_created_at: moment('2024-07-01').toISOString(),
    date_time_updated_at: moment('2024-07-15').toISOString(),
    phases: [
      {
        phase_id: 'demo-clinical-phase-4',
        phase_name: 'Phase 1',
        scheduled_date: '2024-07-12',
        status: TX_PLAN_STATUS.ACCEPTED,
        items: [
          createPhaseItem(
            'demo-clinical-item-7',
            'demo-clinical-phase-4',
            'proc-c7',
            'D2150',
            'Amalgam restoration - two surfaces',
            '3/MO',
            650,
          ),
        ],
      },
    ],
  },
]
